import { useState, useCallback } from "react";

// Универсальный хук для получения статы сервера
const useServerQuery = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const fetchData = useCallback(() => {
    setLoading(true);
    fetch("https://stats.interworld.fun/Nitrado/Query", {
      headers: { Accept: "application/json" },
    })
      .then((res) => res.json())
      .then(setData)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);
  return { fetchData, data, loading };
};

export default useServerQuery;